import { combineEpics } from 'redux-observable';
import { GroupPermission } from '@reducers/data/shareStatuses/groups';
import { createSharingActions, createSharingEpicActionCreators, createSharingEpics } from './utils';

const actionCreators = createSharingEpicActionCreators('GROUP');

export const {
  fetchShareStatus: fetchGroupShareStatus,
  shareWithEmail: shareGroupWithEmail,
  unshareWithSharee: unshareGroupWithSharee,
  addPermissionForSharee: addGroupPermissionForSharee,
  removePermissionForSharee: removeGroupPermissionForSharee,
  sharePublicly: shareGroupPublicly,
  unsharePublicly: unshareGroupPublicly,
  addPublicPermission: addGroupPublicPermission,
  removePublicPermission: removeGroupPublicPermission,
} = createSharingActions<GroupPermission>('GROUP', actionCreators);

export const groupShareStatusesEpic = combineEpics(...createSharingEpics('GROUP', actionCreators));
